import "./AddPartner.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddPartnerComponentController from "./AddPartnerComponentController";

export default class AddPartnerComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddPartnerComponentController;
        this.templateUrl = "/App/Components/Partners/AddPartner/AddPartner.html";
    }
}

module("mmManagePortal").component("irAddPartner", new AddPartnerComponent());
